import React from "react";
import Modal from "react-bootstrap/Modal";


const formatMoney = (value) => {
  const number = Number(value);

  if (!Number.isFinite(number)) {
    return "0.00";
  }

  return number.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};


function OnlineReceiptLinksModal({
  show,
  onHide,
  rows,
  className,
  isArabic = false,
}) {
  const labels = isArabic
    ? {
        title: "الإيصالات المرتبطة بالسحب",
        receipt: "الإيصال",
        invoice: "الفاتورة",
        client: "العميل / الموزّع",
        usd: "المبلغ USD",
        lbp: "المبلغ LBP",
        close: "إغلاق",
      }
    : {
        title: "Cash Out Linked Receipts",
        receipt: "Receipt",
        invoice: "Invoice(s)",
        client: "Client / Reseller",
        usd: "Amount USD",
        lbp: "Amount LBP",
        close: "Close",
      };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      className={className}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {labels.title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr>
                {[
                  labels.receipt,
                  labels.invoice,
                  labels.client,
                  labels.usd,
                  labels.lbp,
                ].map((label) => (
                  <th
                    key={label}
                    style={{
                      padding: "10px",
                      textAlign: "start",
                      borderBottom:
                        "1px solid currentColor",
                    }}
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {(rows || []).map(
                (row, index) => (
                  <tr
                    key={
                      `${row.receipt_id}-${index}`
                    }
                  >
                    <td
                      style={{
                        padding: "10px",
                        borderBottom:
                          "1px solid currentColor",
                      }}
                    >
                      {row.receipt_id || "-"}
                    </td>

                    <td
                      style={{
                        padding: "10px",
                        borderBottom:
                          "1px solid currentColor",
                      }}
                    >
                      {row.invoice_display || "-"}
                    </td>

                    <td
                      style={{
                        padding: "10px",
                        borderBottom:
                          "1px solid currentColor",
                      }}
                    >
                      {row.client_name || "-"}
                    </td>

                    <td
                      style={{
                        padding: "10px",
                        borderBottom:
                          "1px solid currentColor",
                      }}
                    >
                      {formatMoney(
                        row.amount_usd
                      )}
                    </td>

                    <td
                      style={{
                        padding: "10px",
                        borderBottom:
                          "1px solid currentColor",
                      }}
                    >
                      {formatMoney(
                        row.amount_lbp
                      )}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="online-secondary-button"
          onClick={onHide}
        >
          {labels.close}
        </button>
      </Modal.Footer>
    </Modal>
  );
}


export default OnlineReceiptLinksModal;
